import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Image from 'react-bootstrap/Image';
import Bnc from '../Bnc.jpg';
import MonCash from '../MonCash.jpg';
import LajanCash from '../LajanCash.png';
import Button from 'react-bootstrap/Button';
import { FaRegCheckSquare } from 'react-icons/fa';

const Mode_paiement = ({
  setCurrentform,
  currentform,
  infoPh,
  setInfoPh,
  candidatSelectionne,
  setCandidatSelectionne,
  methode_paiement,
  setMethode_paiement,
}) => {
  const [date_trx, setDate_trx] = useState('');
  const [id_trx, setId_trx] = useState('');
  return (
    <div className='row'>
      <div className='col-sm-12 col-md-8 offset-md-2 col-lg-8 offset-lg-2'>
        <div className='card mb-3'>
          <div className='card-header'>
            <h2 className='display-5 text-center'>Mode de Paiement</h2>
          </div>
          <div className='card-body'>
            <div className='row d-flex justify-content-center'>
              <Form>
                <Form.Row className=' mb-1'>
                  <div className='col-sm-12'>
                    <ul style={{ minWidth: '350px' }} className='list-group'>
                      <li
                        className='list-group-item'
                        onClick={(e) => setMethode_paiement('0')}
                      >
                        <div className='d-flex justify-content-between'>
                          <Image
                            src={Bnc}
                            style={{
                              marginLeft: '30px',
                              width: '80px',
                              height: '80px',
                            }}
                          />
                          {/* {methode_paiement} */}
                          {methode_paiement == '0' && (
                            <FaRegCheckSquare size={30} color={'cyan'} />
                          )}
                        </div>
                        <div>
                          <h5 className='text-bold'>
                            {' '}
                            # Compte : XXXX-XXXX-XXX-XXX
                          </h5>
                          <h6> Nom du Compte : DDE de XXXXXXXX</h6>
                        </div>
                      </li>
                      <li
                        className='list-group-item '
                        onClick={(e) => setMethode_paiement('1')}
                      >
                        <div className='d-flex justify-content-between'>
                          <Image
                            src={LajanCash}
                            style={{ marginLeft: '30px', height: '80px' }}
                          />

                          {methode_paiement == '1' && (
                            <FaRegCheckSquare size={30} color={'cyan'} />
                          )}
                        </div>
                        <div>
                          <h5 className='text-bold'>
                            {' '}
                            # Compte : XXXX-XXXX-XXX-XXX
                          </h5>
                          <h6> Nom du Compte : DDE de XXXXXXXX</h6>
                        </div>
                      </li>
                      <li
                        className='list-group-item'
                        onClick={(e) => setMethode_paiement('2')}
                      >
                        <div className='d-flex justify-content-between'>
                          <Image
                            src={MonCash}
                            style={{ marginLeft: '30px', height: '80px' }}
                          />

                          {methode_paiement == '2' && (
                            <FaRegCheckSquare size={30} color={'cyan'} />
                          )}
                        </div>
                        <div>
                          <h5 className='text-bold'>
                            {' '}
                            # Compte : XXXX-XXXX-XXX-XXX
                          </h5>
                          <h6> Nom du Compte : DDE de XXXXXXXX</h6>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Form.Row>
                {/* <div className='container'> */}
                <Form.Row>
                  <Button
                    className='btn-block'
                    style={{ marginTop: '20px', marginBottom: '10px' }}
                    variant='primary'
                    onClick={(e) => {
                      if (methode_paiement == '0')
                        setCurrentform(currentform + 2);
                      else setCurrentform(currentform + 1);
                    }}
                  >
                    Continuer
                  </Button>
                </Form.Row>
                {/* </div> */}
              </Form>
            </div>
          </div>

          <div className='card-footer'></div>
        </div>
      </div>
    </div>
  );
};

export default Mode_paiement;
